import { Component, HostListener, Input, OnChanges } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, startWith } from 'rxjs/operators';

import { Navbar, NavigationItem } from '@ot/shared/model';
import { NavigationLinkService } from './navigation-link.service';

const externalLinks: string[] = [
  'https://www.omnitracs.com/terms-use',
  'https://kb.omnitracs.com/Omnitracs_Tax_Manager'
];

@Component({
  selector: 'ot-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnChanges {
  links$: Observable<NavigationItem[]>;

  @Input() navbar: Navbar;

  constructor(
    private router: Router,
    private linkService: NavigationLinkService
  ) {}

  ngOnChanges() {
    if (this.navbar && Array.isArray(this.navbar.links)) {
      this.links$ = this.router.events.pipe(
        startWith(new NavigationEnd(0, '/', '/')),
        filter(event => event instanceof NavigationEnd),
        map(_ => this.linkService.mapActiveLinks(this.navbar.links))
      );
    }
  }

  // Intercept click and delegate navigation to angular for internal links
  @HostListener('click', ['$event'])
  clickout(event: Event) {
    const anchor = (event.target as HTMLElement).closest('a');
    if (anchor) {
      const url = anchor.getAttribute('href');
      if (
        this.linkService.isLink(anchor) &&
        this.linkService.isInternalLink(anchor)
      ) {
        event.preventDefault();
        this.router.navigateByUrl(url);
      } else if (externalLinks.includes(url)) {
        event.preventDefault();
        window.open(url, '_blank');
      }
    }
  }
}
